import 'whatwg-fetch';
import * as React from 'react';
import { Route } from 'react-router';
import { ROOT_INDEX } from '../constants/routes';
import Main from './main';
import AppProviders from './providers/AppProviders';
import { HashRouter } from 'react-router-dom';

export function App() {
  return (
    <HashRouter>
      <AppProviders>
        <Route path={ROOT_INDEX} component={Main} />
      </AppProviders>
    </HashRouter>
  );
}
